export const INPROCESS = 'Inprocess';
export const APPROVED = 'Approved';
export const REJECTED = 'Rejected';
export const status = {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
};
